<template>
  <el-dialog title="产量工序登记信息修改"  :visible.sync="visible" width="650px" :close-on-click-modal="false">
    <div v-loading="loading">
      <el-form :model="form" ref="formRef" label-width="120px" label-suffix="：" >
        <el-form-item label="项目名称" prop="projectName">
          <span>{{ form.projectName }}</span>
        </el-form-item>
        <el-form-item label="流程名称" prop="processName">
          <span>{{ form.processName }}</span>
        </el-form-item>
        <el-form-item label="工序名称" prop="detailName">
          <span>{{ form.detailName }}</span>
        </el-form-item>
        <el-form-item label="工序价格" prop="processPrice">
          <span>{{ form.detailPrice }}</span>
        </el-form-item>
        <el-form-item label="工序备注" prop="processNotes">
          <span>{{ form.detailNotes }}</span>
        </el-form-item>
        <el-form-item v-if="form.detailType === processDetailType.computeItem" label="登记数量" prop="scrollCount">
          <el-input-number :min="0" :max="99999999" v-model="form.scrollCount" placeholder="登记数量" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item v-if="form.detailType === processDetailType.noteItem" label="备注" prop="notes">
          <el-input v-model="form.notes" placeholder="备注"></el-input>
        </el-form-item>
        <el-form-item label="生产日期" prop="createTime">
          <el-date-picker v-model="form.createTime" type="date" value-format="yyyy-MM-dd" placeholder="选择生产日期"></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </div>
  </el-dialog>
</template>

<script>
import { processDetailType } from '@/data/processDetailType';
import productionWorkingLogApi from '@/api/productionWorkingLogApi';
export default {
  props: {
  },
  data() {
    return {
      visible: false,
      loading: false,
      form: {
      },
      processDetailType,
      defaultWorkingCount: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      scrollCountList: [],
    }
  },
  methods: {
    onOpen(data){
      this.visible = true
      this.$nextTick(()=>{
        this.form = JSON.parse(JSON.stringify(data))
      })
    },
    close() {
      this.scrollCountList = []
      this.visible = false;
    },
    async submit() {
      if(this.form.detailType === processDetailType.computeItem && !this.form.scrollCount ) {
        return this.$message.warning('请填写登记数量')
      }
      if(this.form.detailType === processDetailType.noteItem && !this.form.notes) {
        return this.$message.warning('请填写备注')
      }
      if(!this.form.createTime) {
        return this.$message.warning('请选择生产日期')
      }
      this.loading = true
      const { data: res } = await productionWorkingLogApi.updateLog(this.form).catch(err => err)
      if(res) {
        this.$message.success('操作成功')
        this.close()
        this.$emit('success')
        this.$store.dispatch('message/setMessageCount')
      }
      this.loading = false
    }
  }
}
</script>

<style scoped lang="less">
</style>
